import { createContext } from "react";

export type DialogOptions = {
  title?: string | React.ReactNode;
  content?: string | React.ReactNode;
  confirmText?: string;
  cancelText?: string;
  onConfirm?: () => void | Promise<void>;
  onCancel?: () => void;
  isShowCloseIcon?: boolean;
};

export type DialogContextType = {
  open: boolean;
  title?: string | React.ReactNode;
  content?: string | React.ReactNode;
  confirmText: string;
  cancelText: string;
  onConfirm?: () => void | Promise<void>;
  onCancel?: () => void;
  openDialog: (options: DialogOptions) => void;
  closeDialog: () => void;
};

export const DialogContext = createContext<DialogContextType | null>(null);
